import React, { useContext } from 'react';

import AddToBasketButton from '../../../ProductCard/AddToBasket/AddToBasketButton';
import BrandLogo from '../../../ProductCard/BrandLogo';
import CompareButton from '../../../ProductCard/CompareButton/CompareButton';
import { Context } from '../../store/store';
import CustomCatBullets from '../../customCategory/CustomCatBullets';
import CustomCatDeliveryInformation from '../../customCategory/CustomCatDeliveryInformation';
import CustomCatEnergyInformation from '../../customCategory/CustomCatEnergyInformation';
import CustomCatPricePod from '../../customCategory/CustomCatPricePod@default';
import CustomCatProductImage from '../../customCategory/CustomCatProductImage';
import ExVat from '../../../ProductCard/ExVat';
import Heading from '../../../ProductCard/Heading';
import LargeListViewSkeleton from './Skeletons/LargeListViewSkeleton';
import MoreInfo from '../../../ProductCard/MoreInfo';
import PromoFlag from '../../../ProductCard/PromoFlag';
import ReviewRating from '../../../ProductCard/ReviewRating/ReviewRating';
import StockStatus from '../../../ProductCard/StockStatus';
import { listerClickThrough } from '../../../../actions/lister-actions';
import { useDispatch } from 'react-redux';

export const LargeListViewContent = ({ product }) => {
	const [contextState] = useContext(Context);
	const { loaded } = contextState;

	const dispatch = useDispatch();

	if (!product) {
		return null;
	}

	if (!loaded) {
		return <LargeListViewSkeleton />;
	}

	return (
		<div className="flex-col w-full">
			<div className="flex">
				<div className="flex justify-center flex-col p-2 w-3/5">
					<PromoFlag {...product} />
					<CustomCatProductImage {...product} />
				</div>

				<div className="flex flex-col justify-between p-2 w-2/5">
					<a
						href={product.FullProductUrl}
						onClick={(event) => {
							event.preventDefault();
							window.location.assign(product.FullProductUrl);

							dispatch(listerClickThrough(product.Code));
						}}
						className="inline-block"
						itemProp="url"
						data-testid="product-card-link">
						<BrandLogo {...product} />

						<Heading content={product.FullTitle} />
					</a>

					<ReviewRating {...product} />

					<div className="mt-3 md:mt-0 mb-2">
						<CustomCatPricePod
							viewModel={product.PricePodViewModel}
							stockStatus={product.State}
						/>

						<ExVat />
					</div>

					{product.State !== 'OutOfStock' && <AddToBasketButton {...product} />}

					{product.State === 'OutOfStock' && (
						<StockStatus
							stockStatus={product.State}
							productCode={product.Code}
						/>
					)}

					<div className="flex">
						<MoreInfo {...product} classes="mt-2" />

						<CompareButton
							classes="mt-auto"
							sku={product.Code}
							brand={product.Brand}
						/>
					</div>

					<div className="flex justify-end mt-2">
						{product.State !== 'OutOfStock' && (
							<CustomCatDeliveryInformation
								deliveryInformation={product.DynamicDeliveryBulletsViewModel}
								classes="mr-auto"
							/>
						)}
					</div>

					<CustomCatEnergyInformation
						classes="text-center mt-2 flex items-center"
						energyRatingDetails={product.EnergyRatingDetails}
					/>
				</div>
			</div>
			<CustomCatBullets content={product.FeatureDescriptions} />
		</div>
	);
};

export default LargeListViewContent;
